// LLM 実行メタ（トークン使用量 + 実測コスト）の契約（PRODUCT_DEV-582）。
// agentic-job(idea-review / idea-design-thinking) の result.meta に載せ、実行後の
// 実測コストを UI に表示するために使う。すべて optional で後方互換（既存 result には無い）。
import { z } from "zod";

export const LlmUsageSchema = z.object({
  inputTokens: z.number(),
  outputTokens: z.number(),
  cacheReadTokens: z.number().optional(),
  cacheWriteTokens: z.number().optional(),
});
export type LlmUsage = z.infer<typeof LlmUsageSchema>;

export const LlmMetaSchema = z.object({
  model: z.string().optional(),
  usage: LlmUsageSchema.optional(),
  costUsd: z.number().optional(), // 実測トークン × モデルレートで算出（ops worker が注入）
});
export type LlmMeta = z.infer<typeof LlmMetaSchema>;
